import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Footer from "./../Layout/Footer2";
import Header from "./../Layout/Header";
import { Helmet } from 'react-helmet';
import LogoComponent from './../Element/LogoComponent';
import api from './Api';

const axios = require("axios");

class JobDescription extends Component {

    constructor(props) {
        super(props);

        this.state = {
            myresponse: [],
            isLoading: true,
            otherJobs: [],
            otherJobsLoading: true
        };

        const jobId = window.location.pathname.split('/')[2];

        this.getJob(jobId);
    }

    componentDidMount() {
        // Store the current job ID for comparison
        this.currentJobId = window.location.pathname.split('/')[2];
    }

    componentDidUpdate(prevProps, prevState) {
        // Check if the job ID in the URL has changed
        const newJobId = window.location.pathname.split('/')[2];
        
        // If the job ID changed, reload the job data
        if (newJobId !== this.currentJobId && newJobId) {
            this.currentJobId = newJobId;
            this.setState({
                myresponse: [],
                isLoading: true,
                otherJobs: [],
                otherJobsLoading: true
            });
            this.getJob(newJobId);
        }
        
        // Fetch other jobs when main job data is loaded
        if (prevState.myresponse !== this.state.myresponse && 
            this.state.myresponse && 
            this.state.myresponse.company && 
            this.state.otherJobsLoading) {
            this.getOtherJobs();
        }
    }

    getOtherJobs() {
        const company = this.state.myresponse.company;
        const currentJobId = this.state.myresponse.id;

        if (!company) {
            this.setState({ otherJobsLoading: false });
            return;
        }

        // Llamar al endpoint para obtener trabajos actuales de la compañía
        axios
            .request(api.getJobs('', '', '', company))
            .then((response) => {
                // Filtrar el trabajo actual de los resultados
                const filteredJobs = (response.data.jobs || []).filter(job => 
                    job.id !== currentJobId
                ).slice(0, 2); // Limitar a 2 trabajos

                this.setState({
                    otherJobs: filteredJobs,
                    otherJobsLoading: false
                });
            })
            .catch((error) => {
                console.error('Error fetching other jobs:', error);
                this.setState({ 
                    otherJobs: [],
                    otherJobsLoading: false 
                });
            });
    }

    getJob(jobId) {
        var options = {};
        var headers = {};
        var url = "";

        if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
            url = 'http://localhost:8080/jobs/' + jobId;
        } else {
            // url = "https://open-to-work-remote-api.p.rapidapi.com/jobs/" + jobId;
            // headers = {
            //     "X-RapidAPI-Key": "61c95e0e86msh784d6d5dfb4761dp1ed5e9jsn7923c8051dc2",
            //     "X-RapidAPI-Host": "open-to-work-remote-api.p.rapidapi.com",
            //     "X-Source": "OpenToWorkRemote.com",
            // };
            url = "https://opentoworkremote-api.herokuapp.com/jobs/" + jobId;
        }

        options = {
            method: "GET",
            url: url,
            params: {},
            headers: headers
        };

        axios
            .request(options)
            .then((response) => {
                this.setState({
                    myresponse: response.data,
                    isLoading: false
                });
            })
            .catch(function (error) {
                console.error(error);
                if (error.response && error.response.status === 404) {
                    console.log('Job Not Found, redirecting...');
                    window.location.href = '/';
                }
            });
    }

    decodeEntities(html) {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = html;
        return textarea.value;
    }

    renderSkeletonLoader() {
        return (
            <div className="widget bg-white p-lr20 p-t20 widget_getintuch radius-sm">
                <br />
                <div className="text-center">
                    <div className="skeleton-circle"></div>
                </div>
                <div className="skeleton-line w-75 mx-auto mt-4"></div>
                <div className="skeleton-line w-50 mx-auto mb-4"></div>
                
                {/* <div className="skeleton-line w-25 mb-4">ss</div> */}
                
                <ul>
                    {[1, 2, 3, 4, 5].map((item, index) => (
                        <li key={index} className="d-flex align-items-center mb-3">
                            <div className="skeleton-circle-small mr-2"></div>
                            <div className="w-100">
                                <div className="skeleton-line w-25 mb-1"></div>
                                <div className="skeleton-line w-75"></div>
                            </div>
                        </li>
                    ))}
                </ul>
                <div className="text-center mt-4">
                    <div className="skeleton-button mx-auto"></div>
                </div>
                <br />
            </div>
        );
    }

    render() {
        const { myresponse, isLoading, otherJobs, otherJobsLoading } = this.state;
        const jobId = window.location.pathname.split('/')[2];
        let canonical = "https://www.opentoworkremote.com/view/" + jobId;

        // const showGoBackButton = window.history.length > 1;

        const publicationDate = new Date(myresponse.publicationDate2);
        const currentDate = new Date();
        const differenceInTime = currentDate - publicationDate;
        const differenceInDays = differenceInTime / (1000 * 3600 * 24);
        const isMoreThan45Days = differenceInDays > 45;
        const isExpired = differenceInDays > 90;

        const showTheJobDescription = myresponse.description && ['OpenToWorkRemote', 'Greenhouse', 'Lever', 'WWR', 'Workable', 'Remotive', 'WorkingNomads', 'Himalayas', 'LandingJobs', 'GetOnBrd', 'Zobjobs', 'SportsTech', 'SmartRecruiters', 'EchoJobs', 'RealWorkFromAnywhere', 'Ashby'].includes(myresponse.source);

        let urlToApply = `/apply/${myresponse.id}?url=${myresponse.url}`;
        if (myresponse && myresponse.url && myresponse.url.toString().indexOf("@") !== -1) {
            urlToApply = "mailto:" + myresponse.url;
        }

        const isDisabled = myresponse.enabled === 0;

        return (
            <div>
                <Helmet>
                    <title>
                        {isLoading 
                            ? 'Loading Job Details - Open To Work Remote'
                            : `${myresponse.title || ''} at ${myresponse.company || ''} | ${
                                myresponse.location === 'Remote.' || !myresponse.location
                                    ? 'Remote Job'
                                    : `${myresponse.location} Job`
                            }`
                        }
                    </title>
                    <meta name="description" content={
                        isLoading 
                            ? 'Loading remote job opportunity details...'
                            : `Apply now for ${myresponse.title} position at ${myresponse.company}. ${
                                myresponse.location === 'Remote.' || !myresponse.location
                                    ? 'Remote opportunity'
                                    : `${myresponse.location} opportunity`
                            }${
                                myresponse.salaryRange ? ` - Salary: ${myresponse.salaryRange}` : ''
                            }. Find the best remote jobs at Open To Work Remote.`
                    } />
                    <link rel="canonical" href={canonical} />

                    {/* Open Graph tags for social sharing */}
                    <meta property="og:title" content={`${myresponse.title || ''} at ${myresponse.company || ''}`} />
                    <meta property="og:description" content={`${myresponse.title || ''} position at ${myresponse.company || ''}. ${myresponse.location || 'Remote'} opportunity. Apply now!`} />
                    <meta property="og:url" content={canonical} />
                    <meta property="og:type" content="job" />
                    <meta property="og:site_name" content="Open To Work Remote" />
                    <meta property="og:image" content={myresponse.logo || 'https://www.opentoworkremote.com/og-image-screenshot.png'} />
                    <meta property="og:image:width" content="1200" />
                    <meta property="og:image:height" content="630" />
                    <meta property="og:image:alt" content={`${myresponse.title || 'Job opportunity'} at ${myresponse.company || 'company'} - Open To Work Remote`} />

                    {/* Twitter Card tags */}
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content={`${myresponse.title || ''} at ${myresponse.company || ''}`} />
                    <meta name="twitter:description" content={`${myresponse.title || ''} position at ${myresponse.company || ''}. ${myresponse.location || 'Remote'} opportunity. Apply now!`} />
                    <meta name="twitter:image" content={myresponse.logo || 'https://www.opentoworkremote.com/og-image-screenshot.png'} />
                    <meta name="twitter:image:alt" content={`${myresponse.title || 'Job opportunity'} at ${myresponse.company || 'company'} - Open To Work Remote`} />

                    {/* Additional SEO meta tags */}
                    <meta name="keywords" content={`remote jobs, ${myresponse.title}, ${myresponse.company}, remote work, ${myresponse.location || 'remote'}, job opportunity`} />
                    <meta name="robots" content={(isDisabled || isExpired) ? "noindex, nofollow" : "index, follow"} />

                    {/* Job posting structured data */}
                    <script type="application/ld+json">
                        {`
                            {
                                "@context": "https://schema.org",
                                "@type": "JobPosting",
                                "title": "${myresponse.title || ''}",
                                "description": ${JSON.stringify(
                                    myresponse.description2
                                        ? myresponse.description2
                                        : `${myresponse.company} is hiring a ${myresponse.title} ${
                                            myresponse.location === 'Remote.' 
                                                ? 'for remote work' 
                                                : myresponse.location 
                                                    ? `in ${myresponse.location}` 
                                                    : 'for remote work'
                                        }${myresponse.workType ? `. This is a ${myresponse.workType} position` : ''}${
                                            myresponse.salaryRange ? ` with a salary range of ${myresponse.salaryRange}` : ''
                                        }. Join our team and work with a great company!`
                                )},
                                "datePosted": "${myresponse.publicationDate || ''}"
                                ${(!isDisabled && !isExpired && myresponse.publicationDate) ? `,
                                "validThrough": "${(() => {
                                    const date = new Date(new Date(myresponse.publicationDate).getTime() + (90 * 24 * 60 * 60 * 1000));
                                    date.setUTCHours(23, 59, 59, 999);
                                    return date.toISOString();
                                })()}"` : ''}
                                ${myresponse.workType ? `,"employmentType": "${myresponse.workType}"` : ''},
                                "hiringOrganization": {
                                    "@type": "Organization",
                                    "name": "${myresponse.company || ''}",
                                    "logo": "${myresponse.logo || ''}"
                                },
                                ${myresponse.location === 'Remote.' || !myresponse.location
                                    ? `"jobLocationType": "TELECOMMUTE",
                                       "applicantLocationRequirements": {
                                           "@type": "Country",
                                           "name": "Worldwide"
                                       }`
                                    : `"jobLocation": {
                                        "@type": "Place",
                                        "address": {
                                            "@type": "PostalAddress",
                                            "addressCountry": "${myresponse.location}"
                                        }
                                      }`
                                }
                                ${myresponse.salaryRange ? `
                                ,"baseSalary": {
                                    "@type": "MonetaryAmount",
                                    "currency": "USD",
                                    "value": {
                                        "@type": "QuantitativeValue",
                                        "value": "${myresponse.salaryRange}",
                                        "unitText": "YEAR"
                                    }
                                }` : ''}
                            }
                        `}
                    </script>
                </Helmet>

                <div className="page-wraper">
                    <Header />

                    <div className="page-content bg-white">
                        <div className="dez-bnr-inr bg-dark" style={{height: "100px"}}>
                            <div className="container">
                                <div className="dez-bnr-inr-entry">
                                    <h1 className="text-white" style={{margin: "25px"}}>
                                        {!isLoading && `${myresponse.title} at ${myresponse.company}`}
                                        {isLoading && 'Loading Job Opportunity Details...'}
                                    </h1>
                                </div>
                            </div>
                        </div>

                        {isDisabled &&
                            <div className="content-block">
                                <div className="section-full content-inner-1">
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-lg-4"></div>
                                            <div className="col-lg-5">
                                                <div className="sticky-top">
                                                    <div className="row">
                                                        <div className="col-lg-12 col-md-6">
                                                            <div className="widget bg-white p-lr20 p-t20 widget_getintuch radius-sm">
                                                                <h4 className="text-red text-center">ATTENTION:</h4>
                                                                <h6 className="text-black text-center">This job posting is no longer active or has been disabled.</h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        <div className="content-block">
                            <div className="section-full content-inner-1">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-lg-4"></div>
                                        <div className="col-lg-5">
                                            {isLoading ? (
                                                this.renderSkeletonLoader()
                                            ) : (
                                                <div className="sticky-top">
                                                    <div className="row">
                                                        <div className="col-lg-12 col-md-6">
                                                            <div className="widget bg-white p-lr20 p-t20  widget_getintuch radius-sm">
                                                                <br />
                                                                <div className="text-center">
                                                                    <LogoComponent logoUrl={myresponse.logo} />
                                                                </div>
                                                                <h2 className="text-black font-weight-700 p-t15 m-b15 text-center">{myresponse.company} is Hiring</h2>
                                                                <h5 className="text-black font-weight-700 p-t10 m-b15 text-left">Job Info:</h5>
                                                                <ul>
                                                                    <li><i className="ti-target"></i><strong className="font-weight-700 text-black">Company</strong><span className="text-black-light"><Link to={`/company?q=${myresponse.company}`} > {myresponse.company} </Link></span></li>
                                                                    <li><i className="ti-marker-alt"></i><strong className="font-weight-700 text-black">Position</strong> {myresponse.title} </li>
                                                                    {myresponse.location && (
                                                                        <li><i className="ti-location-pin"></i><strong className="font-weight-700 text-black">Location</strong> {myresponse.location} </li>
                                                                    )}
                                                                    <li><i className="ti-search"></i><strong className="font-weight-700 text-black">Source</strong> {myresponse.source} </li>
                                                                    <li><i className="ti-calendar"></i><strong className="font-weight-700 text-black">Published</strong> {myresponse.publicationDate2} 
                                                                        {isMoreThan45Days && 
                                                                            <span className="text-red" style={{
                                                                                fontSize: '0.8em',
                                                                                marginLeft: '5px',
                                                                                fontStyle: 'italic'
                                                                            }}>
                                                                                (45+ days ago)
                                                                            </span>
                                                                        }
                                                                    </li>
                                                                    {myresponse.category && (
                                                                        <li><i className="ti-tag"></i><strong className="font-weight-700 text-black">Category</strong> {myresponse.category}</li>
                                                                    )}
                                                                    {myresponse.workType && (
                                                                        <li><i className="ti-time"></i><strong className="font-weight-700 text-black">Type</strong> {myresponse.workType} </li>
                                                                    )}
                                                                    {myresponse.experience && (
                                                                        <li><i className="ti-user"></i><strong className="font-weight-700 text-black">Experience</strong> {myresponse.experience} </li>
                                                                    )}
                                                                    {myresponse.salaryRange && (
                                                                        <li><i className="ti-money"></i><strong className="font-weight-700 text-black">Salary</strong> {myresponse.salaryRange} </li>
                                                                    )}
                                                                </ul>
                                                                <br />
                                                                {!showTheJobDescription && !isDisabled && (
                                                                    <div className="text-center">
                                                                        <a href={urlToApply}
                                                                            className="site-button apply-button btn-xl m-2"
                                                                            target="_blank"
                                                                            rel="nofollow noopener noreferrer"
                                                                        >
                                                                            <span className="fa fa-paper-plane"> </span>
                                                                            Go To Job Description
                                                                        </a>
                                                                        <br /><br />
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-2"></div>
                                        <div className="col-lg-8">
                                            <div className="sticky-top">
                                                <div>
                                                    {showTheJobDescription && !isDisabled && (
                                                        <div>
                                                            <br />
                                                            <div className="job-description-section">
                                                                <h4 className="text-black font-weight-700 text-center mb-4">
                                                                    Job Description
                                                                </h4>
                                                                <div className="job-description-content p-4 bg-white rounded" 
                                                                    dangerouslySetInnerHTML={{ 
                                                                        __html: this.decodeEntities(myresponse.description) 
                                                                    }} 
                                                                />
                                                            </div>
                                                            <br />
                                                            <div className="text-center mt-4 pt-3 border-top">
                                                                <a href={urlToApply}
                                                                    className="site-button apply-button btn-lg m-2"
                                                                    target="_blank"
                                                                    rel="nofollow noopener noreferrer"
                                                                >
                                                                    <i className="fa fa-paper-plane mr-2"></i>
                                                                    Go To Apply
                                                                </a>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <br /><br />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Sección de otros trabajos actuales de la misma compañía */}
                        {(!otherJobsLoading && otherJobs && otherJobs.length > 0 && myresponse.company && !isDisabled) && (
                            <div className="content-block">
                                <div className="section-full content-inner-1">
                                    <div className="container">
                                        <div className="other-jobs-section">
                                            <div className="section-header mb-4" style={{
                                                padding: "clamp(16px, 3vw, 24px)", 
                                                backgroundColor: "#ffffff",
                                                borderRadius: "8px",
                                                border: "1px solid #e9ecef",
                                                boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
                                            }}>
                                                <div className="mb-2">
                                                    <div className="d-flex align-items-center justify-content-between flex-wrap" style={{gap: "8px"}}>
                                                        <h3 className="mb-0" style={{
                                                            color: "#333",
                                                            fontWeight: "600",
                                                            fontSize: "1.25rem",
                                                            lineHeight: "1.3",
                                                            wordBreak: "break-word",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            flexWrap: "wrap",
                                                            flex: 1
                                                        }}>
                                                            <i className="fa fa-briefcase me-2" style={{color: "#6c757d", fontSize: "1rem"}}></i>
                                                            &nbsp;&nbsp;
                                                            <span>More Current Jobs at {myresponse.company}</span>
                                                        </h3>
                                                        <span className="badge d-none" style={{
                                                            backgroundColor: "#28a745",
                                                            color: "white",
                                                            fontSize: "0.75rem",
                                                            fontWeight: "500",
                                                            padding: "4px 8px",
                                                            borderRadius: "12px",
                                                            flexShrink: 0,
                                                            marginLeft: "8px"
                                                        }}>
                                                            {otherJobs.length} Active
                                                        </span>
                                                    </div>
                                                </div>
                                                <p className="text-muted" style={{fontSize: "0.9rem", marginBottom: "0"}}>
                                                    Apply to other open positions at {myresponse.company}
                                                </p>
                                            </div>
                                            
                                            <div className="row">
                                                {otherJobs.map((job, index) => (
                                                    <div key={job.id} className="col-lg-6 col-md-6 mb-4">
                                                        <Link to={`/view/${job.id}`} style={{textDecoration: "none", color: "inherit"}}>
                                                            <div className="other-job-card h-100" style={{
                                                                border: "1px solid #e9ecef",
                                                                borderRadius: "8px",
                                                                padding: "20px",
                                                                backgroundColor: "#ffffff",
                                                                transition: "all 0.3s ease",
                                                                position: "relative",
                                                                cursor: "pointer"
                                                            }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.transform = "translateY(-2px)";
                                                            e.currentTarget.style.boxShadow = "0 4px 15px rgba(0,0,0,0.1)";
                                                            e.currentTarget.style.borderColor = "#28a745";
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.transform = "translateY(0)";
                                                            e.currentTarget.style.boxShadow = "none";
                                                            e.currentTarget.style.borderColor = "#e9ecef";
                                                        }}>
                                                            <div className="job-header mb-3">
                                                                <div className="d-flex justify-content-between align-items-start">
                                                                    <div className="job-title-section flex-grow-1">
                                                                        <h5 className="job-title mb-2" style={{
                                                                            color: "#333",
                                                                            fontWeight: "600",
                                                                            fontSize: "1.1rem",
                                                                            lineHeight: "1.3"
                                                                        }}>
                                                                            {job.title}
                                                                        </h5>
                                                                        <div className="job-meta d-flex flex-wrap gap-2 mb-2">
                                                                            {job.location && (
                                                                                <span className="badge" style={{
                                                                                    backgroundColor: "#e9ecef",
                                                                                    color: "#6c757d",
                                                                                    fontSize: "0.75rem",
                                                                                    fontWeight: "500",
                                                                                    padding: "4px 8px"
                                                                                }}>
                                                                                    <i className="fa fa-map-marker me-1"></i>
                                                                                    &nbsp;&nbsp;
                                                                                    {job.location}
                                                                                </span>
                                                                            )}
                                                                            &nbsp;&nbsp;
                                                                            {job.source && (
                                                                                <span className="badge" style={{
                                                                                    backgroundColor: "#e3f2fd",
                                                                                    color: "#1976d2",
                                                                                    fontSize: "0.75rem",
                                                                                    fontWeight: "500",
                                                                                    padding: "4px 8px"
                                                                                }}>
                                                                                    {job.source}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    {job.logo && (
                                                                        <div className="company-logo ms-3">
                                                                            <img 
                                                                                src={job.logo} 
                                                                                alt={`${myresponse.company} logo`} 
                                                                                style={{
                                                                                    width: "40px",
                                                                                    height: "40px",
                                                                                    objectFit: "contain",
                                                                                    borderRadius: "6px",
                                                                                    border: "1px solid #dee2e6"
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            
                                                            <div className="job-details">
                                                                {job.salaryRange && (
                                                                    <div className="salary-info mb-2">
                                                                        <span className="salary-badge" style={{
                                                                            backgroundColor: "#e8f5e8",
                                                                            color: "#2e7d32",
                                                                            fontSize: "0.85rem",
                                                                            fontWeight: "600",
                                                                            padding: "4px 10px",
                                                                            borderRadius: "4px"
                                                                        }}>
                                                                            <i className="fa fa-dollar me-1"></i>
                                                                            {job.salaryRange}
                                                                        </span>
                                                                    </div>
                                                                )}
                                                                
                                                                <div className="job-date mb-3">
                                                                    <small className="text-muted" style={{fontSize: "0.8rem"}}>
                                                                        <i className="fa fa-calendar me-1"></i>
                                                                        &nbsp;&nbsp;
                                                                        Posted: {job.publicationDate2 || job.publicationDate}
                                                                    </small>
                                                                </div>
                                                                
                                                                <div className="job-actions">
                                                                    <div 
                                                                        className="btn btn-outline-success btn-sm"
                                                                        style={{
                                                                            fontSize: "0.85rem",
                                                                            padding: "6px 12px",
                                                                            borderRadius: "4px",
                                                                            textDecoration: "none",
                                                                            transition: "all 0.3s ease",
                                                                            display: "inline-block"
                                                                        }}
                                                                    >
                                                                        <i className="fa fa-eye me-1"></i>
                                                                        &nbsp;&nbsp;
                                                                        View & Apply
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            
                                                            {/* Indicador de trabajo activo */}
                                                            <div className="active-indicator" style={{
                                                                position: "absolute",
                                                                top: "10px",
                                                                right: "10px",
                                                                backgroundColor: "#28a745",
                                                                color: "white",
                                                                fontSize: "0.7rem",
                                                                padding: "2px 6px",
                                                                borderRadius: "10px",
                                                                fontWeight: "500"
                                                            }}>
                                                                Active
                                                            </div>
                                                        </div>
                                                        </Link>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Loading state para otros trabajos */}
                        {(otherJobsLoading && myresponse.company && !isDisabled) && (
                            <div className="content-block">
                                <div className="section-full content-inner-1">
                                    <div className="container">
                                        <div className="other-jobs-loading">
                                            <div className="section-header mb-4">
                                                <h3 className="section-title mb-2" style={{
                                                    color: "#333",
                                                    fontWeight: "600",
                                                    fontSize: "1.25rem",
                                                    lineHeight: "1.2"
                                                }}>
                                                    <i className="fa fa-briefcase me-2" style={{color: "#6c757d"}}></i>
                                                    Other Current Jobs at {myresponse.company}
                                                </h3>
                                            </div>
                                            
                                            <div className="loading-message" style={{
                                                backgroundColor: "#f8f9fa",
                                                border: "1px solid #e9ecef",
                                                borderRadius: "8px",
                                                padding: "30px",
                                                textAlign: "center"
                                            }}>
                                                <div className="spinner-border text-primary" role="status" style={{
                                                    width: "2rem",
                                                    height: "2rem",
                                                    marginBottom: "15px"
                                                }}>
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                                <p className="text-muted mb-0" style={{fontSize: "0.95rem"}}>
                                                    Loading other opportunities at {myresponse.company}...
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}

export default JobDescription;
